__turbopack_context__.v({
  "selectVariantMessage": "SelectVariantMessage-module-scss-module__ElA_fW__selectVariantMessage",
});
